import { useRef } from 'react';

const VARIANTS = new Set([
  'discovery-segmented',
  'configuration-tabs',
]);

export default function ApplicationLocalNavigation({
  ariaLabel,
  items,
  value,
  onChange,
  variant = 'discovery-segmented',
  className = '',
}) {
  const itemRefs = useRef([]);

  if (!VARIANTS.has(variant)) {
    throw new Error(
      `Unsupported ApplicationLocalNavigation variant: ${variant}`
    );
  }

  const focusItem = (index) => {
    itemRefs.current[index]?.focus();
  };

  const handleKeyDown = (event, currentIndex) => {
    const enabledIndexes = items
      .map((item, index) => (item.disabled ? null : index))
      .filter((index) => index !== null);
    const enabledPosition = enabledIndexes.indexOf(currentIndex);

    if (enabledPosition < 0) {
      return;
    }

    let nextPosition;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextPosition = (enabledPosition + 1) % enabledIndexes.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextPosition =
          (enabledPosition - 1 + enabledIndexes.length) %
          enabledIndexes.length;
        break;
      case 'Home':
        nextPosition = 0;
        break;
      case 'End':
        nextPosition = enabledIndexes.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    focusItem(enabledIndexes[nextPosition]);
  };

  const classes = [
    'av-app-local-navigation',
    `av-app-local-navigation--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      aria-label={ariaLabel}
      className={classes}
      role="tablist"
    >
      {items.map((item, index) => {
        const selected = item.value === value;

        return (
          <button
            aria-controls={item.controls}
            aria-selected={selected}
            className="av-app-local-navigation__item"
            disabled={item.disabled}
            id={item.id}
            key={item.value}
            onClick={() => onChange(item.value)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            ref={(element) => {
              itemRefs.current[index] = element;
            }}
            role="tab"
            tabIndex={selected ? 0 : -1}
            type="button"
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
